import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'reactstrap';
import ApplicantEditDialogBody from './ApplicantEditDialogBody';
import ApplicantEditDialogHeader from './ApplicantEditDialogHeader';

const ApplicantEditDialog = ({ show, onHide, id, isEdit, rtl }) => {
  const [modal, setModal] = useState({
    isOpen: show,
    title: `${isEdit ? 'Edit' : 'Add'} Applicant`,
    hide: onHide,
  });

  return (
    <Modal
      isOpen={show}
      toggle={modal.hide}
      backdrop="static"
      modalClassName={`${rtl.direction}-support`}
      className="modal-dialog--primary modal-dialog--header"
    >
      <ApplicantEditDialogHeader modal={modal} />
      <ApplicantEditDialogBody modal={modal} isEdit={isEdit} id={id} />
    </Modal>
  );
};

export default connect((state) => ({
  rtl: state.rtl,
}))(ApplicantEditDialog);
